"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSidebar = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSidebar = styled_components_1.default.aside `
  grid-area: sidebar;
  background-color: #fff;
  width: 435px;
  max-height: 100%;
  overflow-y: hidden;

  .MuiTabs-root {
    .MuiTabs-flexContainer {
      border-bottom: 2px solid ${ui_components_1.baseColors.gray300};
    }

    .MuiTab-root.Mui-selected {
      color: ${ui_components_1.baseColors.primaryBlueDark500};
    }
    
    .MuiTabs-indicator {
      background-color: ${ui_components_1.baseColors.primaryBlueDark500}; 
    }
  }

  .MuiTabPanel-root {
    padding: 0;
    max-height: calc(100% - 50px);
    overflow-y: auto;
  }
`;
